import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { BiTrash } from 'react-icons/bi';
import { FaEdit } from 'react-icons/fa';
import { allowAlphabetAndSpacesOnly } from '../../CommonUtils/CommonValidations';

export default function AddComponent() {
    const [componentlist, setcomponentList] = useState([]);
    const [editData, setEditData] = useState(null);
    const [showErrorMsg, setErrorMsg] = useState(false)
    const dispatch = useDispatch();
    const componentFormik = useFormik({
        initialValues: {
            compId: "",
            compName: "",
        },
        validationSchema: Yup.object({
            compName: Yup.string().required(ERROR_MSG).nullable()
        }),
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveComponent`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {

                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                backdrop: false,
                            }).then((resdayfordiff) => {
                                if (resdayfordiff?.isConfirmed === true) {
                                    componentFormik.setFieldValue("compName", "");
                                    componentFormik.setFieldValue("compId", "");
                                    setEditData(null)
                                    GetComponentList()
                                }
                            });
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })
    function GetComponentList() {
        let url = config.url.API_URL + `componentdetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcomponentList(res?.data?.componentDetails);
                setErrorMsg(false)
            }
            else {
                setcomponentList([]);
                setErrorMsg(true)
            }
        })
    }

    function EditComponent(compid) {
        let url = config.url.API_URL + "editComponent/" + compid;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                componentFormik.setFieldValue("compName", res?.data?.componentList[0]?.comp_name);
                componentFormik.setFieldValue("compId", res?.data?.componentList[0]?.comp_id);
            }
        })
    }
    function UpdateComponent(updateformikvalues) {
        Swal.fire({
            text: 'Are you sure you want to update?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const url = config.url.API_URL + "saveUpdateComponent";
                CommonAxiosPost(url, updateformikvalues).then((res) => {
                    if (res?.data?.scode === '01') {


                        Swal.fire({
                            text: res?.data?.sdesc,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            backdrop: false,
                        }).then((resdayfordiff) => {
                            if (resdayfordiff?.isConfirmed === true) {
                                componentFormik.setFieldValue("compName", "");
                                componentFormik.setFieldValue("compId", "");
                                setEditData(null)
                                GetComponentList();
                            }
                        });
                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            } else {
                console.log('Submission canceled');
            }
        });
    }
    function DeleteComponent(comp_id) {
        Swal.fire({
            text: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const url = config.url.API_URL + "deleteComponent?compID=" + comp_id;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {


                        Swal.fire({
                            text: res?.data?.sdesc,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            backdrop: false,
                        }).then((resdayfordiff) => {
                            if (resdayfordiff?.isConfirmed === true) {
                                GetComponentList();
                            }
                        });
                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            } else {
                console.log('Submission canceled');
            }
        });
    }
    useEffect(() => { GetComponentList() }, [])
    return (
        <div>

            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-3" >
                <CommonFormHeading heading="Compnent " />
                <FormikProvider value={componentFormik}>
                    <Form onSubmit={componentFormik.handleSubmit} onChange={componentFormik.handleChange}>
                        <bie.Row className='pt-1'>
                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}></bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <label className="label-text-style mb-1"><b style={{ color: 'red' }}>* </b>Component</label>
                                <Field type="text" className="form-control" name="compName" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} maxLength="250" />
                                <ErrorMessage name="compName" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} >
                                {editData ?
                                    <button type="button" className="btn btn-success btn-sm float-end mt-4" onClick={() => {
                                        UpdateComponent(componentFormik?.values)
                                    }}>Update</button> :
                                    <button type="submit" className="btn btn-success btn-sm float-end mt-4">Submit</button>}
                            </bie.Col>
                        </bie.Row>
                    </Form>
                </FormikProvider>
                <center>
                    {componentlist.length > 0 ?
                        <div className="table-responsive mt-4">
                            <table className="table table-condensed table-bordered  table-responsive affl-table" style={{ width: "80%" }}>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Component Name</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {componentlist && componentlist?.map((cmp, index) => (<>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: "left" }}>{cmp?.comp_name} </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                                    EditComponent(cmp.comp_id)
                                                    setEditData(true)
                                                }}> <FaEdit size={18} /></button>
                                            </td>
                                            <td>
                                                <button type="button" className="btn btn-danger btn-sm"
                                                    onClick={() => { DeleteComponent(cmp.comp_id) }}>
                                                    <BiTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    </>))}

                                </tbody>
                            </table>

                        </div> : showErrorMsg === true ? (<center><b style={{ color: "red" }}>*********No Data Found*********</b></center>) : ("")}
                </center>
            </Container>
        </div>
    )
}
